import { render, staticRenderFns } from "./CardResumeOffer.vue?vue&type=template&id=34b8fb9f&scoped=true&"
import script from "./CardResumeOffer.vue?vue&type=script&lang=js&"
export * from "./CardResumeOffer.vue?vue&type=script&lang=js&"
import style0 from "./CardResumeOffer.vue?vue&type=style&index=0&id=34b8fb9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b8fb9f",
  null
  
)

export default component.exports